import { Container, XStack, YStack, SizableText, shadowStandard, Stack, Spinner } from '@my/ui'
import React from 'react'
import { MainLayout, Meta, NAV_HEIGHT, NAV_HEIGHT_SM } from 'app/components'
import { BrandListItem, BrandListItemProps } from '../../components/brand-list/brand-list-item'
import { createAToZArray } from 'app/utils/create-a-to-z-array'
import { groupBrandsByAlphabet } from '../../lib/group-brands-by-alphabets'
import { BrandAToZTabs, BrandGroupItemTitle } from '../../components'
import { useNextRouter } from 'app/hooks/use-next-router'
import './brands-screen.css'
import { IFRAME_NAV_HEIGHT } from 'app/components/layout/navigation/iframe-navigation.web'
import { useIFrame } from 'app/provider/iframe'

export interface BrandsScreenProps {
  brands: BrandListItemProps[]
  loading: boolean
}

export const BrandsScreen = (props: BrandsScreenProps) => {
  const { brands } = props
  const router = useNextRouter()
  const { isIframe } = useIFrame()
  const path = router.asPath
  const currentSelectedLetter = path.split('#').pop() || 'a'

  const letters = createAToZArray()
  const groupBrands = groupBrandsByAlphabet(brands)


  return (
    <MainLayout>
      <Meta title="Brands A - Z" />

      <YStack bg="$background" w="100%" pb="$3.5">
        <Container gap="$3.5" gutter size="base" flex={1} spaceTop>
          <XStack jc="space-between" columnGap="$3.5" rowGap="$2" ai="center" flexWrap="wrap">
            <SizableText size="$9" fow="600">
              Brands A - Z
            </SizableText>
          </XStack>
        </Container>
      </YStack>

      <Container
        alignSelf="flex-start"
        pos={'sticky' as 'absolute'}
        top={isIframe ? IFRAME_NAV_HEIGHT : NAV_HEIGHT}
        gutter="gtSm"
        size="base"
        zIndex="$2"
        pb="$3.5"
        $gtSm={{
          top: isIframe ? `calc(${IFRAME_NAV_HEIGHT} + 16px)` : `calc(${NAV_HEIGHT_SM}px + 16px)`,
        }}
      >
        <Stack p="$3.5" bg="$white" br="$3" overflow="hidden" {...shadowStandard}>
          <BrandAToZTabs
            letters={letters}
            currentSelectedLetter={currentSelectedLetter.toLocaleLowerCase()}
            onPress={() => {}}
          />
        </Stack>
      </Container>

      <Container size="base" gutter spaceBottom>
        {!props.loading &&
          groupBrands.map((group) => {
            return (
              <YStack key={group.groupName} gap="$3.5" pb="$3.5">
                <Stack id={group.groupName} pos="absolute" o={0} top={-196} />
                <BrandGroupItemTitle title={group.groupName} />
                <Stack className="BrandsGrid">
                  {group.items.map((brand) => (
                    <BrandListItem key={brand.id} {...brand} />
                  ))}
                </Stack>
              </YStack>
            )
          })}
        {props.loading && (
          <YStack gap="$3.5" py="$3.5" minHeight={100}>
            <Spinner size="large" color="$black" />
          </YStack>
        )}
      </Container>
    </MainLayout>
  )
}
